module.exports = "<div class=\"row no-gutters justify-content-end\">\r\n   <rw-button variant=\"outlined\"\r\n              class=\"mr-2\"\r\n              action=\"$ctrl.openEntryDialog()\">\r\n      <translate>\r\n         New FAQ Entry\r\n      </translate>\r\n   </rw-button>\r\n\r\n   <rw-button variant=\"outlined\"\r\n              action=\"$ctrl.openCategoryDialog()\">\r\n      <translate>\r\n         New Category\r\n      </translate>\r\n   </rw-button>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/faq/components/faq-management/faq-management.html
// module id = 1312
// module chunks = 0